import { buildAuthToken } from 'utils/build-auth-token';
import config from 'config';

async function fetchWrapper(url, options) {
	var objOptions = options || {};
	var includeCredentials = { credentials: 'include' };

	var obj = { ...includeCredentials, ...objOptions };

	obj.headers = obj.headers || new Headers();

	obj.headers.append('Ocp-Apim-Subscription-Key', config.APIM_SUBSCRIPTION_KEY);
	obj.headers.append('Authorization', `Bearer ${await buildAuthToken()}`);
	return fetch(url, obj);
}

export default fetchWrapper;
